'use client'

import { VisualEditing } from 'next-sanity'
// import { useEffect } from 'react'

export default function SanityVisualEditing() {
	// useEffect(() => {
	// 	// If not an iframe or a Vercel Preview deployment, turn off Draft Mode
	// 	if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'preview' && window === parent) {
	// 		location.href = '/api/draft-mode/disable'
	// 	}
	// }, [])

	return (
		<>
			<VisualEditing />
			<div className="fixed bottom-4 left-4 z-[99999] inline-flex items-center gap-2 rounded-full bgWite border-solid border border-black/50 p-2 font-system text-[14px] leading-100 bg-white/80 text-black hover:text-black">
				<div className="icon">
					<LivePreviewIcon />
				</div>
				<a href="/api/disable-draft" className="relative pr-1 text-black">
					Exit Live Preview
				</a>
			</div>
		</>
	)
}

function LivePreviewIcon() {
	return (
		<svg
			className="block w-5 h-5 animate-pulse"
			stroke="currentColor"
			fill="none"
			strokeWidth="2"
			viewBox="0 0 24 24"
			strokeLinecap="round"
			strokeLinejoin="round"
			height="1em"
			width="1em"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			<path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
			<path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"></path>
			<path d="M15.9 20.11l0 .01"></path>
			<path d="M19.04 17.61l0 .01"></path>
			<path d="M20.77 14l0 .01"></path>
			<path d="M20.77 10l0 .01"></path>
			<path d="M19.04 6.39l0 .01"></path>
			<path d="M15.9 3.89l0 .01"></path>
			<path d="M12 3l0 .01"></path>
			<path d="M8.1 3.89l0 .01"></path>
			<path d="M4.96 6.39l0 .01"></path>
			<path d="M3.23 10l0 .01"></path>
			<path d="M3.23 14l0 .01"></path>
			<path d="M4.96 17.61l0 .01"></path>
			<path d="M8.1 20.11l0 .01"></path>
			<path d="M12 21l0 .01"></path>
		</svg>
	)
}
